import { styled } from "styled-components";
const DropdownMenuTextComponent = styled.div`
  padding: 4px 8px;
  color: ${({ theme }) => theme.color.gray7};
  line-height: ${({ theme }) => theme.lineHeight.default};
  font-family: ${({ theme }) => theme.fontFamily.default};
  font-size: ${({ theme }) => theme.fontSize.default};
`;
export {
  DropdownMenuTextComponent
};
